import React from 'react'
import { BrowserRouter, Route, Routes } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import LoginPage from './pages/LoginPage/LoginPage';
import BookCategoryPage from './pages/BookCategoryPage/BookCategoryPage';
import CategoryPage from './pages/CategoryPage/CategoryPage';
import BookListPage from './pages/BookListPage/BookListPage';
import BookDetailPage from './pages/BookDetailPage/BookDetailPage';
import NewsSourcesPage from './pages/NewsSourcesPage/NewsSourcesPage';
import NewsCategoriesPage from './pages/NewsCategoriesPage/NewsCategoriesPage';
import NewsArticlesPage from './pages/NewsArticlesPage/NewsArticlesPage';
import AccessNews from './pages/News/InfoAccess';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path='/' Component={CategoryPage} />
        <Route path='/category/:language/books' Component={BookCategoryPage} />
        <Route path='/category/:language/:mainCategory/:category' Component={BookListPage} />
        <Route path='/news' Component={AccessNews}/>
        <Route path='/category/:language/news/sources' Component={NewsSourcesPage} />
        <Route path='/category/:language/news/:source/categories' Component={NewsCategoriesPage} />
        <Route path='/category/:language/news/:source/:category/articles' Component={NewsArticlesPage} />
        <Route path='/category/:mainCategory/:category' Component={BookListPage} />
        <Route path='/login' Component={LoginPage} />
        <Route path='/play/:mainCategory/:category/:bookName' Component={BookDetailPage} />
      </Routes>
    </BrowserRouter>
  )
}

export default App;
